import React from "react";
import PageHero from "@/components/PageHero";
import { Container, GoldButton } from "@/components/shared";

export default function About() {
  return (
    <div>
      <PageHero
        kicker="About · A private crossing, held in public"
        title="An independent project"
        intro="Made in Boston is built and kept by a private citizen. It is not a council website, not a City of Boston programme, not Boston 400, and not a government initiative."
      />

      <section className="py-16 sm:py-24">
        <Container>
          <div className="max-w-3xl mx-auto space-y-6 font-sans text-lg text-[#1B2430] leading-relaxed">
            <p>
              This is an independent business-to-business platform connecting two towns that share a
              name: Boston in Lincolnshire, the <strong>mother town</strong>, and Boston in
              Massachusetts, the <strong>daughter city</strong>. The name crossed the Atlantic in
              1630. Four hundred years on, in 2030, two working harbours still have goods to move and
              skills to trade — and this crossing exists to make that trade practical.
            </p>
            <p>
              It is not a charity and it is not pure nostalgia. It is a commercial directory, a
              marketplace, and a members' forum, organised by sector. We use the words
              <em> mother town</em> and <em>daughter city</em> deliberately, and we avoid the
              language of official twinning. There is no council behind this, no ribbon, no
              programme. Civic partners are welcome to appear here later, but only as listings or
              advertisers — like everyone else.
            </p>
            <p>
              We try to tell the history plainly and honestly, including the parts that are not
              comfortable: the peninsula the settlers renamed was Shawmut, the land of the
              Massachusett people. A crossing worth keeping should hold the whole story.
            </p>

            <div className="bg-[#FFFAF3] border-l-4 border-[#CDA434] p-8 my-8">
              <p className="font-playfair italic text-xl text-[#1E1E2F]">
                “A private crossing, held in public.”
              </p>
            </div>

            <h2 className="font-serif text-2xl text-[#003366] pt-4">Correspondence</h2>
            <p>
              Written correspondence may be sent to <strong>75 High Street, Boston, Lincolnshire</strong>
              (correspondence only — not a visitor address). For anything else, email
              {" "}<a href="mailto:info@madeinboston.co.uk" className="text-[#003366] link-underline">info@madeinboston.co.uk</a>.
            </p>
          </div>

          <div className="max-w-3xl mx-auto mt-10 flex flex-wrap gap-3">
            <GoldButton as="link" to="/contact">Write to us</GoldButton>
            <GoldButton as="link" to="/story/1630" className="bg-transparent border border-[#003366] text-[#003366] hover:bg-[#003366] hover:text-[#FFFAF3]">
              Read the 1630 story
            </GoldButton>
          </div>
        </Container>
      </section>
    </div>
  );
}
